import request from '@/config/axios'

export interface DashboardStatsVO {
  shopId: string | number
  statDate: string
  totalRooms: number
  occupiedRooms: number
  availableRooms: number
  bookedRooms: number
  checkoutRooms: number
  unavailableRooms: number
  checkInCount: number
  checkOutCount: number
  currentOccupancy: number
  newBookingCount: number
  cancelCount: number
  revenue: number
  occupancyRate: number
  cleaningCount: number
  maintenanceCount: number
  alertCount: number
}

export interface TrendItemVO {
  date: string
  value: number
}

// 获取Dashboard统计数据
export const getDashboardStats = (params: { shopId?: string | number; statDate?: string }) => {
  return request.get<DashboardStatsVO>({ url: '/hotel/dashboard/stats', params })
}

// 获取入住率趋势（近30天）
export const getOccupancyTrend = (params: { shopId?: string | number }) => {
  return request.get<TrendItemVO[]>({ url: '/hotel/dashboard/occupancy-trend', params })
}

// 获取营收趋势（近30天）
export const getRevenueTrend = (params: { shopId?: string | number }) => {
  return request.get<TrendItemVO[]>({ url: '/hotel/dashboard/revenue-trend', params })
}
